import React from "react"
import { twMerge } from "tailwind-merge"

import ReviewStars from "../../components/shared/ReviewStars"

const MeetPractitionerSection = ({ practice, className }) => {
  const reviewCount = practice.reviews?.length || 0
  const userName =
    practice.user?.firstName && practice.user?.lastName
      ? `${practice.user.firstName} ${practice.user.lastName}`
      : practice.user?.name
  const theme = practice.theme
  const profilePhotoUrl = practice.user?.profilePhotoUrl

  return (
    <div className={twMerge("flex flex-col", className)}>
      {/* Profile Photo */}
      <div className="mb-8 h-56 w-56 shrink-0">
        {profilePhotoUrl ? (
          <img src={profilePhotoUrl} alt={userName} className="h-full w-full rounded-2xl object-cover" />
        ) : (
          <div className="flex h-full w-full items-center justify-center rounded-2xl bg-gray-light">
            <span className="text-3xl font-bold" style={{ color: theme.colorTextDark }}>
              {userName?.charAt(0)?.toUpperCase() || "?"}
            </span>
          </div>
        )}
      </div>

      {/* Content */}
      <div className="flex-1">
        {/* Meet the Practitioner Header */}
        <p
          className="mb-4 text-lg font-medium"
          style={{
            color: theme.colorTextDark,
            fontFamily: theme.fontParagraph
          }}>
          Meet the Practitioner
        </p>

        {/* Practitioner Name */}
        <h2
          className="mb-6 text-4xl font-bold lg:text-3xl"
          style={{
            color: theme.colorTextDark,
            fontFamily: theme.fontHeading,
            fontWeight: theme.fontHeadingWeight
          }}>
          {userName}
        </h2>

        {/* Star Rating and Review Count */}
        <div className="mb-8 flex items-center gap-3">
          <ReviewStars
            rating={practice.averageRating}
            filledColor={theme.colorReviewStars}
            emptyColor={theme.colorGrey}
          />
          <span className="text-lg font-medium" style={{ color: theme.colorTextDark }}>
            {reviewCount} reviews
          </span>
        </div>

        {/* About Text */}
        {practice.about && (
          <div
            className="text-lg leading-relaxed"
            style={{
              color: theme.colorTextDark,
              fontFamily: theme.fontParagraph
            }}
            dangerouslySetInnerHTML={{ __html: practice.about }}
          />
        )}
      </div>
    </div>
  )
}

export default MeetPractitionerSection
